import React, { useEffect, useState } from 'react'
import ReviewConfirmationView from './components/ReviewSummaryView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const ReviewSummary = ({ i18n }) => {

  const [isError, setIsError] = useState(false)
  useEffect(() => {
    try {
      addToGoogleDataLayer('review-summary', 'Pay a Debt', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language])

  return isError ? <Error /> : <ReviewConfirmationView setIsError={setIsError} />
}

export default withTranslation('common')(ReviewSummary)
